import { select } from "redux-saga/effects";
import {L} from "../reducer";

export function* getRequestData(lists, params) {
    const List = yield select(state => state.List);

    // Prepare request data
    const requestData = {
        lists: [],
        params: {},
    };

    lists.forEach(item => {
        switch (item) {
            case L.countries: // Skip if exists
                // if (!List.countries.length)
                requestData.lists.push(item);
                break;
            case L.state_list:
                requestData.lists.push(item);
                requestData.params[item] = {
                    country_code: params[item]?.country_code,
                };
                break;
            case L.currencies:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.currencyVersion,
                };
                break;
            case L.contact_groups:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.contactGroupVersion,
                };
                break;
            case L.contacts:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.contactVersion,
                };
                break;
            // case L.products:
            //     requestData.lists.push(item);
            //     requestData.params[item] = {
            //         version: List.productVersion,
            //     };
            //     break;
            case L.accounts:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.accountVersion,
                };
                break;
            case L.terms:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.termVersion,
                };
                break;
            case L.tag_groups:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.tagVersion,
                };
                break;
            case L.asset_types:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.assetVersion,
                };
                break;
            case L.fields:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.fieldVersion,
                };
                break;
            case L.number_formats:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.numberFormatsVersion,
                };
                break;
            case L.locations:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.locationVersion,
                };
                break;
            case L.tax_codes: // No version control
                requestData.lists.push(item);
                break;
            case L.settings:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.settingVersion,
                };
                break;
            // case L.limits:
            //     requestData.lists.push(item);
            //     break;
            case L.company_addresses:
                requestData.lists.push(item);
                requestData.params[item] = {
                    contact_id: params[item]?.contact_id,
                };
                break;
            case L.contact_addresses:
                requestData.lists.push(item);
                requestData.params[item] = {
                    contact_id: params[item]?.contact_id,
                };
                break;
            case L.contact_persons:
                requestData.lists.push(item);
                requestData.params[item] = {
                    contact_id: params[item]?.contact_id,
                };
                break;
            case L.payment_methods:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.paymentMethodVersion,
                };
                break;
            case L.price_levels:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.priceLevelVersion,
                };
                break;
            case L.users:
                requestData.lists.push(item);
                break;
            case L.advisors:
                requestData.lists.push(item);
                break;
            case L.clients:
                requestData.lists.push(item);
                break;
            case L.product_list:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.productListVersion,
                };
                break;
            case L.product_groups:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.productGroupVersion,
                };
                break;
            case L.classification_code_list:
                requestData.lists.push(item);
                break;
            case L.product_detail:
                requestData.lists.push(item);
                requestData.params[item] = {
                    product_id: params[item]?.product_id,
                    type: params[item]?.type,
                    contact_id: params[item]?.contact_id,
                    date: params[item]?.date,
                    currency_code: params[item]?.currency_code,
                };
                break;

            case L.product_detail_list:
                requestData.lists.push(item);
                requestData.params[item] = {
                    product_ids: params[item]?.product_ids,
                    type: params[item]?.type,
                    contact_id: params[item]?.contact_id,
                    date: params[item]?.date,
                    currency_code: params[item]?.currency_code,
                };
                break;
            case L.form_designs:
                requestData.lists.push(item);
                requestData.params[item] = {
                    version: List.formDesignsVersion,
                };
                break;
            case L.flow_streams:
                requestData.lists.push(L.flow_streams);
                break;
            default:
                break;
        }
    });

    return requestData;
}
